import { MessageSquare } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useAppDispatch } from "../../app/hooks";
import { openSubjectThread } from "../../features/messages/slice-extensions/messages-slice-extension";
import { ROUTES } from "../../routes";

interface MessageSubjectButtonProps {
  kind: "group" | "session";
  subjectId: string;
  className?: string;
}

/** "Message the group" / "Message the class": opens (or starts) the Group's or the Session's thread. */
const MessageSubjectButton = ({ kind, subjectId, className = "btn btn-secondary" }: MessageSubjectButtonProps) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);

  const open = async () => {
    setBusy(true);
    const result = await dispatch(openSubjectThread({ kind, subjectId }));
    setBusy(false);
    if (openSubjectThread.fulfilled.match(result)) {
      navigate(ROUTES.MESSAGE_THREAD.replace(":threadId", result.payload.id));
    } else {
      toast.error(t("messages.openFailed"));
    }
  };

  return (
    <button type="button" className={`${className} flex items-center gap-1.5`} onClick={open} disabled={busy}>
      <MessageSquare size={18} strokeWidth={2} />
      <span>{t(kind === "group" ? "messages.action.messageGroup" : "messages.action.messageClass")}</span>
    </button>
  );
};

export default MessageSubjectButton;
